import { FAILED_SESSIONS } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  failedSessions: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const failedSessionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FAILED_SESSIONS.REQUEST: {
      return { ...state, isLoading: true };
    }
    case FAILED_SESSIONS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failedSessions: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FAILED_SESSIONS.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default failedSessionsReducer;

